import {
  resolvePropertyValue,
  splitPropPath,
} from "@cayo/shared/components/Form/modelUtils/auxPropsUtils";
import { buildModel, initPickers } from "./build-model";
import { getODataTypes } from "./field-odata-type-mapper";
import { getEditableItems, getModel, getVisibleItems } from "./get-model";
import { normalizeModelForComplexType } from "./model-normalizers";

const modelUtils = {
  buildModel,
  getModel,
  getEditableItems,
  initPickers,
  getVisibleItems,
  resolvePropertyValue,
  splitPropPath,
  normalizeModelForComplexType,
  getODataTypes,
};

export default modelUtils;
